import { render, staticRenderFns } from "./trimepay.vue?vue&type=template&id=974929d4&"
import script from "./trimepay.vue?vue&type=script&lang=js&"
export * from "./trimepay.vue?vue&type=script&lang=js&"
import style0 from "./trimepay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports